(function(){
  'use strict';
  var codes=['pickup','bpost_home','bpost_point'],states=new WeakMap();
  function state(root,route){var routes=states.get(root);return routes&&routes[route];}
  function ready(root,route){return !!(state(root,route)&&state(root,route).ready);}
  function modes(root,route){return ready(root,route)?state(root,route).rows.slice():[];}
  function cents(value){
    if(typeof value!=='number'||value<0||!Number.isFinite(value)||!Number.isSafeInteger(Math.round(value*100))||Number(value.toFixed(2))!==value)throw Error('Montant invalide');
    return Math.round(value*100);
  }
  async function load(root,route,base){
    var routes=states.get(root)||{};states.set(root,routes);routes[route]={ready:false,rows:[]};
    try{
      if(!['bonbonnieres','traditional'].includes(route)||!['https://staging.mariacrea.be','https://app.mariacrea.be'].includes(base))throw Error('Configuration invalide');
      var response=await window.fetch(base+'/api/public/quote-reception-modes?route='+route,{method:'GET',credentials:'omit',cache:'no-store',redirect:'error',signal:AbortSignal.timeout(5000)});
      if(!response.ok)throw Error('API indisponible');
      var data=await response.json(),seen=[];
      if(!data||!Array.isArray(data.modes)||data.modes.length>codes.length)throw Error('Réponse invalide');
      var rows=data.modes.map(function(row){
        if(!row||!codes.includes(row.code)||seen.includes(row.code)||typeof row.label!=='string'||!row.label.trim()||!Number.isSafeInteger(row.order)||row.order<0)throw Error('Mode invalide');
        seen.push(row.code);
        var result={code:row.code,label:row.label,order:row.order};
        if(route==='bonbonnieres'){result.price=cents(row.price)/100;result.freeShippingThreshold=cents(row.freeShippingThreshold)/100;}
        else if(Object.keys(row).some(function(key){return !['code','label','order'].includes(key);}))throw Error('Contrat traditionnel invalide');
        return result;
      }).sort(function(a,b){return a.order-b.order||codes.indexOf(a.code)-codes.indexOf(b.code);});
      routes[route]={ready:true,rows:rows};return modes(root,route);
    }catch(_error){routes[route]={ready:false,rows:[]};throw Error('Modes de réception temporairement indisponibles.');}
  }
  function render(select,rows,value){
    select.replaceChildren();select.add(new Option('Choisissez le mode de réception',''));
    rows.forEach(function(row){select.add(new Option(row.label,row.code));});
    select.required=true;select.disabled=false;
    select.value=rows.some(function(row){return row.code===value;})?value:'';return select.value;
  }
  function delivery(root,code,lines){
    var unavailable={status:'unavailable',deliveryGross:null,deliveryDiscount:null,delivery:null,deliveryFreeReason:null};
    if(!ready(root,'bonbonnieres'))return unavailable;
    if(!code)return {status:'incomplete',deliveryGross:0,deliveryDiscount:0,delivery:0,deliveryFreeReason:null};
    var mode=modes(root,'bonbonnieres').find(function(row){return row.code===code;});
    if(!mode)return unavailable;
    var gross=cents(mode.price),threshold=cents(mode.freeShippingThreshold);
    var net=(lines||[]).reduce(function(sum,line){return sum+Math.round(Number(line.finalTotal||0)*100);},0);
    var rule=(lines||[]).some(function(line){return line.freeDelivery===true;});
    var reached=threshold>0&&net>=threshold,discount=rule||reached?gross:0;
    return {status:'ok',deliveryGross:gross/100,deliveryDiscount:discount/100,delivery:(gross-discount)/100,deliveryFreeReason:discount>0?(rule?'rule':'threshold'):null};
  }
  window.MCQuoteReception={load:load,ready:ready,modes:modes,render:render,delivery:delivery};
})();
